import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { INDUSTRIES, IMAGES } from "../data/site";

const Industries = () => (
    <div data-testid="industries-page">
        <PageHero
            kicker="INDUSTRIES"
            title="Applications Across Demanding"
            accent="Industrial Environments"
            sub="Industrial heating and control technology applies wherever temperature must be precise, repeatable and reliable."
            image={IMAGES.molten}
            crumb="Industries"
        />
        <section className="bg-brand-mist py-20 md:py-24 technical-grid-light">
            <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
                    {INDUSTRIES.map((ind, i) => (
                        <Reveal key={ind.name} delay={Math.min(i * 0.05, 0.4)}>
                            <Link to="/get-a-quote" data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="group relative block h-52 overflow-hidden bg-brand-ink md:h-60">
                                <img src={ind.image} alt={`${ind.name} industry applications`} loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover opacity-40 transition-all duration-700 group-hover:scale-105 group-hover:opacity-60" />
                                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/95 to-transparent" />
                                <div className="relative flex h-full flex-col justify-end p-5">
                                    <p className="font-display text-sm font-bold uppercase leading-tight tracking-wide text-white">{ind.name}</p>
                                    <span className="mt-2 h-px w-0 bg-brand-ember transition-all duration-500 group-hover:w-full" />
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.15}>
                    <p className="mt-12 max-w-3xl text-sm leading-relaxed text-slate-500" data-testid="industries-note">
                        Furnace type, temperature range, chamber design and control scope are engineered per application. Share your process requirement and our engineering team will define the right solution.
                    </p>
                    <Link to="/get-a-quote" data-testid="industries-quote-cta"
                        className="group mt-6 inline-flex items-center gap-3 bg-brand-red px-7 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-charcoal">
                        DISCUSS YOUR APPLICATION <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                    </Link>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Industries;
